// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// Si vas a usar Analytics, puedes dejar esta línea
// import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
// NO SE REQUIEREN CAMBIOS AQUÍ, TU CONFIGURACIÓN ESTÁ BIEN
const firebaseConfig = {
  apiKey: "AIzaSyD3zTS6ijHH0_HsaNPtvDm-eIlyUw3x18o",
  authDomain: "rifas-el-pri.firebaseapp.com",
  projectId: "rifas-el-pri",
  storageBucket: "rifas-el-pri.firebasestorage.app",
  messagingSenderId: "1070599909067",
  appId: "1:1070599909067:web:6da522093d4a60c040b54e",
  measurementId: "G-1KC9D6VZY3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

// Inicializa Firestore y expórtalo para que otros archivos lo usen
const db = getFirestore(app);

// Exporta la instancia de la base de datos para usarla en otros archivos
export { db };

// MODIFICACIÓN: Se eliminó una llave de cierre '}' extra que causaba un error de sintaxis.
